function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment } from 'react';
import { PropertyType, listingVisibility } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import SignedIn from './signed-in';
import SignedOut from './signed-out';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NearbySales = _ref => {
  var className = _ref.className,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'vertical' : _ref$layout,
    nearbySales = _ref.nearbySales,
    _ref$listingVisibilit = _ref.listingVisibility,
    vis = _ref$listingVisibilit === void 0 ? {
      duration: 8,
      unit: 'week'
    } : _ref$listingVisibilit,
    _ref$signedIn = _ref.signedIn,
    signedIn = _ref$signedIn === void 0 ? false : _ref$signedIn,
    _ref$signedOutProps = _ref.signedOutProps,
    signedOutProps = _ref$signedOutProps === void 0 ? {} : _ref$signedOutProps;
  var _useAllhomesApi = useAllhomesApi(),
    openSignIn = _useAllhomesApi.openSignIn,
    isSignedIn = _useAllhomesApi.isSignedIn;
  var soldDuration = listingVisibility.toText(vis);
  var propertyType = (nearbySales === null || nearbySales === void 0 ? void 0 : nearbySales.propertyType) && PropertyType[nearbySales.propertyType].pluralLabel.toLowerCase();
  var handleSignIn = () => {
    if (openSignIn) {
      openSignIn();
    }
  };
  return ___EmotionJSX(Fragment, null, nearbySales && propertyType && ___EmotionJSX("div", {
    className: className
  }, ___EmotionJSX(Heading, {
    title: "Nearby sales"
  }), signedIn || isSignedIn ? ___EmotionJSX(SignedIn, {
    layout: layout,
    nearbySales: nearbySales,
    soldDuration: soldDuration,
    propertyType: propertyType
  }) : ___EmotionJSX(SignedOut, _extends({
    layout: layout,
    nearbySales: nearbySales,
    propertyType: propertyType,
    onClick: handleSignIn
  }, signedOutProps))));
};
export default NearbySales;